import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import { useAuth } from './AuthProvider';

export function NoAccessPage() {
  const { user, signOut } = useAuth();
  return (
    // Outside the app layout, so it brings its own main landmark (axe, task 12.2).
    <main>
      <Box padding="xxl">
        <Container header={<Header variant="h1">Access not granted</Header>}>
          <Box>
            Your account is signed in but has not been given access to BDA Blueprint Studio, or does not have access to
            that page. Ask an administrator to add you to the right group.
          </Box>
          <Box padding={{ top: 'm' }}>
            {/* This page sits outside the layout, so it names the user itself (requirement 1.5). */}
            {user && <Box margin={{ bottom: 's' }}>Signed in as {user.name || user.email}</Box>}
            <Button onClick={() => void signOut()}>Sign out</Button>
          </Box>
        </Container>
      </Box>
    </main>
  );
}
